<template>
  <Modal
      v-model="$store.state.newGroupModalVisible"
      :title="'LASP Software Home-Group Information'"
      :mask-closable="false"
      :width="600"
      @on-ok="submit"
      :loading="loading"
      @on-cancel="cancel">
    <!--      <Spin fix v-if="disabled">加载中请耐心等待...</Spin>-->
    <!--      <LaspView @initFinish="disabled = false" :arc-url="arcUrl"></LaspView>-->
    <div>
      <Form :model="formValue" label-position="top" ref="form"  :rules="formRules">
        <FormItem label="Group Leader Email  负责人邮件"  prop="leader_email" >
          <Input v-model="formValue.leader_email" placeholder=" 研究组负责人email务必和您发表论文的通讯地址一致"></Input>
        </FormItem>
        <FormItem label="Affiliation Name  研究单位名称" prop="group_name">
          <Input v-model="formValue.group_name" placeholder=" 研究单位名称务必和您发表的文章的单位名称一致"></Input>
        </FormItem>
        <FormItem label="Affiliation address 研究单位地址" prop="group_addr">
          <Input v-model="formValue.group_addr"></Input>
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script>
import {addUserDownloadApi} from "@/api/userdownload.js";
import {parseTime} from "@/utils";

export default {
  name: "newgroup",
  props: {

  },
  data() {
    return {
      formValue:{
        leader_email:'',
        group_name:'',
        group_addr:'',
      },
      formRules:{
        leader_email: [
          { required: true, message: 'leader_email is required' },
          { type: 'email', message: 'Incorrect email format' }
        ],
        group_name: [
          { required: true, message: 'group_name is required'},
        ],
        group_addr: [
          { required: true, message: 'group_addr is required'},
        ]
      },
      loading:false
    }
  },
  methods:{
    submit() {
      this.$refs['form'].validate((val)=>{
        console.log(val);
        if(val){
          this.loading = true
          addUserDownloadApi({
            ...this.formValue,
            // strfile:this.$store.state.userdownStrfile,
            flag:'A',
            strfile:'FULL_ac',
            uid:this.$store.state.userInfo.uid,
            dt:parseTime(new Date())
          }).then(res=>{
            this.formValue = {
              leader_email:'',
              group_name:'',
              group_addr:'',
            }
            this.$refs['form'].resetFields()
            this.$store.commit('SET_USERDOWN_STRFILE', '')
            this.$store.commit('SET_NEWGROUP_MODAL_Visible', false)
            this.loading = false
          }).catch(err=>{
            this.formValue = {
              leader_email:'',
              group_name:'',
              group_addr:'',
            }
            this.$refs['form'].resetFields()
            this.loading = false
          })
        }
        // 表示校验成功或失败
      });
    },
    cancel(){
      this.formValue = {
        leader_email:'',
        group_name:'',
        group_addr:'',
      }
      this.$refs['form'].resetFields()
      this.$store.commit('SET_USERDOWN_STRFILE', '')
      this.$store.commit('SET_NEWGROUP_MODAL_Visible', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lasp/newGroup.vue